import Component from '../inherited/Component';
import Helpers from '../lib/Helpers';

export default class SlideToggleGroup extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx);
    this._toggleItems = this._elem.querySelectorAll('[data-toggle-item]');
  }

  mount() {
    if (
      this._options.closeOnOutsideClick &&
      matchMedia('only screen and (min-width: 1081px)').matches
    ) {
      document.addEventListener(
        'click',
        (e) => {
          let clickIsInside = this._elem.contains(e.target) || this._elem === e.target;

          if (clickIsInside) return false;

          for (let item of this._toggleItems) {
            let elemToSlide = item.querySelector('[data-toggle-elem]');
            if (item.classList.contains('open')) {
              elemToSlide.classList.remove('open')
              item.classList.remove('open')
            }
          }
        },
        { passive: true }
      );
    }

    for (let item of this._toggleItems) {
      let trigger = item.querySelector('[data-toggle-trigger]');

      trigger.addEventListener('click', (e) => {

        let elemToSlide = item.querySelector('[data-toggle-elem]');

        if (elemToSlide.dataset.transitioning === 'true') {
          return false;
        }

        if (item.classList.contains('open')) {
          elemToSlide.classList.remove('open')
          item.classList.remove('open')
        } else {
          elemToSlide.classList.add('open')
          item.classList.add('open')
        }

        let otherToggles = item.parentNode.querySelectorAll('[data-toggle-item]');

        for (let otherItem of otherToggles) {
          if (
            otherItem !== item &&
            otherItem.classList.contains('open') &&
            otherItem.dataset.transitioning !== 'true'
          ) {
            let elemToSlide = otherItem.querySelector('[data-toggle-elem]');
            elemToSlide.classList.remove('open')
            otherItem.classList.remove('open')
          }
        }
      });

      if(item.dataset.open) {
        let status = item.dataset.open
        if(status == 'desktop' && matchMedia('only screen and (min-width: 1081px)').matches) {
          trigger.click()
        } else if(status == 'mobile' && matchMedia('only screen and (max-width: 1080px)').matches) {
          trigger.click()
        } else if(status == 'all') {
          trigger.click()
        }
      }
    }
  }
}
